export class Point {
  X: number = 0;
  Y: number = 0;
}
